module.exports = __webpack_public_path__ + "assets/img/notice.4636ad2d.svg";